<script>
    import PromotionsList from "../PromotionsList.svelte";
    import {PAGE_ID, router, navigateTo} from "../../stores/router";
    import {selectPromotion} from "../../stores/misc";
    import {promotions} from "../../stores/promotions";

    const onPromotionClick = id => {
        selectPromotion(id);
        navigateTo(PAGE_ID.VIEW_PROMOTION, PAGE_ID.PROMOTIONS);
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.PROMOTIONS}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--        <Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center md:justify-between">
            <div class="min-w-0 flex-1">
                <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Promotions</h2>
            </div>
            <div class="flex flex-shrink-0 md:mt-0 md:ml-4">
                <!--Empty-->
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="px-4 sm:px-6 lg:px-8">
        <PromotionsList promotions_arr_list={$promotions.list} on:promotionClicked={(e) => onPromotionClick(e.detail.id)}></PromotionsList>
    </div>

</div>


<style></style>